<div class="send-money pt-4">
    <div class="row align-items-center w-100 px-4">
        <div class="col pt-2">
            <div class="cash-container-info row align-items-center gap-2">
                <!-- add filters and search here -->
                <div class="search ms-2 d-flex align-items-center rounded-pill col-lg-3 col-sm-8 col-md-5" style="font-size: 13px">
                    <input type="text" class="border-0 ms-2 w-90" placeholder="Search" />
                    <mat-icon class="p-1" style="color: #7e8a96; font-size: 13px">search</mat-icon>
                </div>
                <div class="filter-controls d-sm-flex gap-1 col-md-3">
                    <ng-container *ngFor="let tableFilterTemplate of filterControls" [ngTemplateOutlet]="tableFilterTemplate.templateRef || null"></ng-container>
                </div>
            </div>
        </div>
        <div class="col-md-auto col-sm-12 pt-2">
            <button mat-raised-button class="btn-primary rounded-pill d-flex justify-content-center align-items-center" (click)="openSendMoneyModal()">
                <mat-icon class="me-2 fs-small" svgIcon="top-up-client"></mat-icon><span>Top-up client</span>
            </button>
        </div>
    </div>

    <app-table
        (dataLoadMore)="searchTransactions()"
        [dataColumns]="columns"
        [dataHasMoreRecords]="hasMoreRecords"
        [dataLoading]="loading"
        [dataSortableColumns]="sortableColumns"
        [dataSource]="transactions"
        class="transaction-table"
        dataAbsenceText="No transactions"
        dataName="Recent Transactions"
    >
        <ng-template [appTableColumnDataSource]="transactions" appTableColumn="transaction_timestamp" let-transaction>
            <p>{{ transaction.transaction_timestamp | date : 'dd MMM yyyy' | optionalPlaceholder }}</p>
            <span class="text-muted">{{ transaction.transaction_timestamp | date : 'hh:mm' | optionalPlaceholder }}</span>
        </ng-template>

        <ng-template [appTableColumnDataSource]="transactions" appTableColumn="receiver" let-transaction>
            <div class="d-flex align-items-center">
                <!-- <img [src]="transaction.sender_info.imgUrl" alt="" class="rounded-circle" style="width: 40px; height: 40px" /> -->
                <div>
                    <div class="fw-normal">{{ transaction.receiver_user_id }}</div>
                    <!-- <div class="fw-bold fs-6">{{ transaction.receiver_user_id }}</div> -->
                    <!-- <div class="fw-normal text-muted">{{ transaction.sender_account_id }}</div> -->
                </div>
            </div>
        </ng-template>

        <ng-template [appTableColumnDataSource]="transactions" appTableColumn="sender" let-transaction>
            <div class="d-flex align-items-center">
                <!-- <img [src]="transaction.receiver_info.imgUrl" alt="" class="rounded-circle" style="width: 40px; height: 40px" /> -->
                <div>
                    <!-- <div class="fw-normal">{{ transaction.sender_user_id }}</div> -->
                    <div class="fw-normal">{{ userInfo.first_name + ' ' + userInfo.last_name }}</div>
                    <!-- <div class="fw-normal text-muted">{{ userInfo.email }}</div> -->
                </div>
            </div>
        </ng-template>

        <ng-template [appTableColumnDataSource]="transactions" appTableColumn="amount_received" let-transaction>
            <div class="d-flex align-items-center">
                <div class="wallet-currency rounded-pill p-1 d-flex align-items-center justify-content-between m-2">
                    <div class="d-flex align-items-center justify-content-between rounded-pill p-2" style="background-color: #F0F1F5;">
                        <!-- <img src="../../../assets/home/united states.svg" alt="{{ transaction.sent_currency }}" /> -->
                        <img
                            [src]="'/assets/currency-flags/' + transaction.transaction_currency + '-flag.svg'"
                            [alt]="transaction.transaction_currency"
                            style="width: 12px; height: 12px"
                            class="rounded-circle"
                        />
                        <span class="ms-2" style="font-size: 11px;">{{ transaction.transaction_currency }}</span>
                    </div>
                </div>
                <p class="font-size:13px">{{ transaction.transaction_amount + transaction.fee_amount }}</p>
            </div>
        </ng-template>

        <ng-template [appTableColumnDataSource]="transactions" appTableColumn="amount_sent" let-transaction>
            <div class="d-flex align-items-center">
                <div class="wallet-currency rounded-pill p-1 d-flex align-items-center justify-content-between m-2">
                    <div class="d-flex align-items-center justify-content-between rounded-pill p-2" style="background-color: #F0F1F5;">
                        <img
                            [src]="'/assets/currency-flags/' + transaction.transaction_currency + '-flag.svg'"
                            [alt]="transaction.transaction_currency"
                            style="width: 12px; height: 12px"
                            class="rounded-circle"
                        />
                        <span class="ms-2" style="font-size: 11px;">{{ transaction.transaction_currency }}</span>
                    </div>
                </div>
                <p class="font-size:13px">{{ transaction.transaction_amount }}</p>
            </div>
        </ng-template>

        <ng-template [appTableColumnDataSource]="transactions" appTableColumn="transfer_status" let-transaction>
            <p
                [class.status-badge-failed]="transaction.status_code !== '0000'"
                [class.status-badge-success]="transaction.status_code === '0000'"
                class="py-1 px-4 fw-semibold rounded-pill status-badge"
            >
                {{ transaction.status_code | transferStatus }}
            </p>
        </ng-template>

        <ng-template [appTableColumnDataSource]="transactions" appTableColumn="transaction_type" let-transaction>
            <p class="text-gray">{{ transaction.transaction_type | transactionType | optionalPlaceholder }}</p>
        </ng-template>

        <ng-template [appTableColumnDataSource]="transactions" appTableColumn="action">
            <button class="d-flex align-items-center rounded-pill bg-white text-black view-transaction-details">
                <span class="m-1 fw-semibold view-transaction-details-text">View Details</span>
                <mat-icon class="view-transaction-details-icon" fontIcon="chevron_right" />
            </button>
        </ng-template>

        <ng-template #transactionAbsentValue>N/A</ng-template>
    </app-table>
</div>

<!-- <app-table-filter [filterType]="'checkbox'" filterName="Type" filterSvgIcon="app-user-icon" classes="rounded-pill type-filter" [showExpand]="true">
    <ng-template appTableFilter filterValue="PEER_TO_PEER">Peer to Peer</ng-template>
    <ng-template appTableFilter filterValue="WALLET_TRANSFER">Wallet Transfer</ng-template>
</app-table-filter> -->

<!-- <app-table-filter [filterType]="'radio'" filterName="Date Created" filterSvgIcon="app-table-filter-status" classes="rounded-end-pill">
    <ng-template appTableFilter filterValue="today">Today</ng-template>
    <ng-template appTableFilter filterValue="week">Last Week</ng-template>
    <ng-template appTableFilter filterValue="month">Last Month</ng-template>
</app-table-filter> -->
